import React from 'react'
import Header from "../../../../Components/Header";
import Contact from './Contact';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function ViewContact() {
    const location = useLocation();
    const contact_id = location.state;
    return (
        <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
            <Helmet>
				<title>Contact - View</title>
			</Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
                <Contact contact_id={contact_id} />
            </div>
        </div>
    )
}

export default ViewContact
